module.exports = __webpack_public_path__ + "img/13b.dbdc1de2.jpg";